import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      navigate(res.user.role === "admin" ? "/admin" : "/account");
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="login-page" className="grid min-h-[calc(100vh-73px)] lg:grid-cols-2">
      <div className="hidden bg-obsidian lg:block">
        <img
          src="https://images.unsplash.com/photo-1657632843433-e6a8b7451ac6"
          alt="Abstract"
          className="h-full w-full object-cover opacity-90"
        />
      </div>
      <div className="flex items-center justify-center px-5 py-16 md:px-12">
        <div className="w-full max-w-sm">
          <Link to="/" className="font-serif text-2xl font-medium tracking-tighter text-obsidian">
            LUX<span className="text-signal">•</span>DROP
          </Link>
          <h1 className="mt-8 font-serif text-4xl font-light tracking-tighter text-obsidian">Welcome back</h1>
          <p className="mt-2 text-sm text-obsidian/60">Sign in to view your orders and downloads.</p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-obsidian/60">Email</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full border border-obsidian/20 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-obsidian focus:ring-offset-1"
                placeholder="you@email.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.15em] text-obsidian/60">Password</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full border border-obsidian/20 bg-white px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-obsidian focus:ring-offset-1"
                placeholder="••••••••"
              />
            </div>

            {error && <p data-testid="login-error" className="text-sm text-signal">{error}</p>}

            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-signal py-3.5 text-sm font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-red-700 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <p className="mt-6 text-sm text-obsidian/60">
            No account?{" "}
            <Link to="/register" data-testid="to-register-link" className="font-semibold text-signal hover:underline">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
